import { createContext } from "react";

const PregnancyLossContext = createContext();

export default PregnancyLossContext;
